import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  User,
   ReceiptIndianRupee ,
  UserPlus,
  Building2,
  Megaphone,
  AudioLines,
  ChevronLeft,
  ChevronRight,
  X,
} from "lucide-react";
import ADMINLOGO from "../../assets/images/Prodicus_logo_crm.webp";
import { useAuthStore } from "../../store/authStore";
import { SHOW_VOICE_AND_META } from "../../config/features";

import Image from "../ui/Image";

export default function Sidebar({
  collapsed,
  mobileOpen,
  closeMobileSidebar,
  toggleDesktopSidebar,
}) {
  const { role, user } = useAuthStore();

  const isAdmin = role === "admin";
  const isAgent = user?.role === "agent";

  let logo = ADMINLOGO;
  let userName = "Prodicus";

  if(isAgent) {
    logo = user?.logo_url;
    userName = user?.name;
  }

  // ✅ Memoized menu (prevents unnecessary recalculation)
  const menuItems = useMemo(() => {
    const commonItems = [
      {
        path: "/dashboard",
        name: "Dashboard",
        icon: <LayoutDashboard size={20} />,
      },
      {
        path: isAgent && user?.id ? `/profile/${user.id}` : "/profile",
        name: "Profile",
        icon: <User size={20} />,
      },
      {
        path: "/leads",
        name: "Leads",
        icon: <UserPlus size={20} />,
      },
      {
        path: "/agent-usage",
        name: "Agent Usage",
        icon: <ReceiptIndianRupee className="text-primary" size={20} />,
      },
    ];

    const propertiesItem = {
      path: "/properties",
      name: "Properties",
      icon: <Building2 size={20} />,
    };

    if (isAdmin) {
      return [
        commonItems[0], // Dashboard
        {
          path: "/agents",
          name: "Agents",
          icon: <Users size={20} />,
        },
        propertiesItem,
        commonItems[2], // Leads
        {
          path: "/agents-usage",
          name: "Agent Usage",
          icon: <ReceiptIndianRupee className="text-primary" size={20} />,
        },
        ...(SHOW_VOICE_AND_META
          ? [
              {
                path: "/admin/meta-ads",
                name: "Meta Ads",
                icon: <Megaphone size={20} />,
              },
              {
                path: "/admin/voice-providers",
                name: "Voice providers",
                icon: <AudioLines size={20} />,
              },
            ]
          : []),
      ];
    }

    return [
      commonItems[0], // Dashboard
      commonItems[1], // Profile
      propertiesItem,
      commonItems[2], // Leads
      commonItems[3], // Agent Usage
    ];
  }, [isAdmin, isAgent, user?.id]);

  console.log("menuItems", menuItems);

  return (
    <>
      {/* MOBILE OVERLAY */}
      <div
        className={`mobile-overlay ${mobileOpen ? "overlay-active" : ""}`}
        onClick={closeMobileSidebar}
      />

      {/* DESKTOP SIDEBAR */}
      <aside
        className={`sidebar desktop-sidebar ${
          collapsed ? "sidebar-collapsed" : "sidebar-expanded"
        }`}
      >
        <div className="sidebar-header">
          <div className="sidebar-logo d-flex align-center gap-2">
            <div className="sidebar-logo-image-box">
              <Image src={logo} alt="Prodicus Logo" className="sidebar-logo-image" width={100} height={100} />
              </div>
              <div className="sidebar-logo-text">{userName?.split(" ")[0] || "User"}</div>
              </div>
          <div className="sidebar-logo-icon">{userName?.charAt(0).toUpperCase()}</div>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.name}</span>
            </NavLink>
          ))}
        </nav>

        <button
          className="sidebar-toggle-btn"
          onClick={toggleDesktopSidebar}
          aria-label="Toggle Sidebar"
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </aside>

      {/* MOBILE MENU */}
      <aside className={`mobile-menu ${mobileOpen ? "mobile-menu-open" : ""}`}>
        <div className="mobile-menu-header">
          <div className="sidebar-logo">
            <div className="sidebar-logo-image-box">
              <Image src={logo} alt="Prodicus Logo" className="sidebar-logo-image" width={100} height={100} />
              </div>
              </div>
              <div className="mobile-menu-header-close-btn">
          <button
            className="mobile-close-btn"
            onClick={closeMobileSidebar}
            aria-label="Close Menu"
          >
            <X size={22} />
          </button>
          </div>
        </div>

        <nav className="mobile-menu-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `mobile-nav-item ${isActive ? "active" : ""}`
              }
              onClick={closeMobileSidebar}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.name}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
}